




import { Component, Vue } from 'vue-property-decorator';
import QuotationsTable from '@/modules/quotations/components/QuotationsTable.vue';

@Component({
  components: {
    QuotationsTable,
  },
})
export default class QuotationsOverview extends Vue {

}
